import { tss } from 'tss-react/mui';

import { Stack, Typography } from '@mui/material';

import { GetAppOutlined, LaunchOutlined } from '@mui/icons-material';

import { useState } from 'react';

import type { DocumentType } from '@/gql';
import { graphql } from '@/gql';

import { Or2LinkButton } from '@/components/button/Or2LinkButton';

import { Or2Button } from '@/components/button/Or2Button';

import { GenericError } from '@/components/error/GenericError';

import { downloadFile } from '@/utils/file/fileUtils';

import { ConfirmDownloadDialog } from '../dialogs/ConfirmDownloadDialog';

import { FileIcon } from '../../FileIcon';

import { FileShareOnNoticeboardButton } from './file-view/FileShareOnNoticeboardButton';

const FILE_VIEW_FILES_FOR_OWNER_FRAGMENT = graphql(`
  fragment fileViewFilesForOwnerFields on FilesForOwner {
    ...fileShareOnNoticeboardButtonFilesForOwnerFields
    parent {
      _id
      filename
      preventDownload
      ...fileIconFields
    }
  }
`);

interface Props {
  filesForOwner: DocumentType<typeof FILE_VIEW_FILES_FOR_OWNER_FRAGMENT>;
}

const useStyles = tss.create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4),
  },
}));

export const FileView = ({ filesForOwner }: Props) => {
  const { classes } = useStyles();
  const [confirmDownloadOpen, setConfirmDownloadOpen] = useState(false);

  const { parent: file } = filesForOwner;
  const { _id: fileId, filename, preventDownload } = file ?? {};

  if (!file) {
    return <GenericError />;
  }

  return (
    <div className={classes.root}>
      <FileIcon file={file} size={96} />
      <Typography variant="h5">{filename}</Typography>
      <Stack direction="row" spacing={1} sx={{ marginTop: 1 }}>
        <Or2LinkButton
          href={`/document/${fileId}/view`}
          isExternal // this is a hack to open in another tab
          startIcon={<LaunchOutlined />}
        >
          View
        </Or2LinkButton>
        {!preventDownload && (
          <Or2Button
            startIcon={<GetAppOutlined />}
            onClick={() => setConfirmDownloadOpen(true)}
          >
            Download
          </Or2Button>
        )}
        <FileShareOnNoticeboardButton filesForOwner={filesForOwner} />
      </Stack>
      <ConfirmDownloadDialog
        open={confirmDownloadOpen}
        onClose={() => setConfirmDownloadOpen(false)}
        onConfirm={() => {
          if (fileId) {
            downloadFile(fileId);
          }
        }}
      />
    </div>
  );
};
